/**
 * 页面跳转，主要兼容随管家跳转
 */
define('util/client-jumpto',[
  'util/client-bridge',
  'util/host'
], function(clientBridge, host) {
  return function(url) {
    var _url = host(url);
    window.location.href = _url;
  };
});

